import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'

import App from '~/App.vue'
import router from '~/router'

import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';

import HeroWithImage from '@/views/home/components/HeroWithImage.vue';
import HeroWithVideo from '@/views/home/components/HeroWithVideo.vue';
import globalLocale from '@/locales/global.json';

import { safeHtml } from '@/directives/safe-html'
import envConfig from "../config/envConfig.js";

// Quill styles for the PrimeVue Editor (rich-text email template body).
import 'quill/dist/quill.snow.css';

import Sentry from '~/plugins/sentry';

const app = createApp(App)
app.directive('safe-html', safeHtml)
const i18n = createI18n({
  legacy: false,
  locale: 'en-CA',
  fallbackLocale: 'en-CA',
  message: globalLocale,
})
const pinia = createPinia();

app.use(pinia); // Ensure pinia is registered before using it

app.use(router)
app.use(i18n);

app.component('HeroWithImage', HeroWithImage);
app.component('HeroWithVideo', HeroWithVideo);

app.provide('i18n', i18n);


async function initPrimevue() {
  const { default: WusaTheme } = await import('@clubs/wusa-theme');
  const { default: PrimeVue } = await import('primevue/config');
  app.use(PrimeVue, {
    theme: {
      preset: WusaTheme,
      options: {
        darkModeSelector: '.dark-mode'
      },
    },
    ripple: true
  });
  app.use(ToastService);
  app.use(ConfirmationService);
  app.use(DialogService);


}

async function initializeApp() {
  // Sentry must be registered before mount so it
  // captures errors during the mount lifecycle.
  app.use(Sentry);
  await initPrimevue();

  app.mount('#app');
}

initializeApp();